export const title = 'Вы\u00A0действительно хотите покинуть встречу?';
export const text = 'Вы\u00A0можете присоединиться позже. Это можно сделать по\u00A0ссылке в\u00A0чате Тренда или из\u00A0смс';
export const cancelText = 'Отменить';
export const acceptText = 'Покинуть встречу';
